import script from "./NotificacionesCampana.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificacionesCampana.vue?vue&type=script&lang=ts&setup=true"

import "./NotificacionesCampana.vue?vue&type=style&index=0&id=53a812ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a812ae"]])

export default __exports__